import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const NavBar = ({ activeLink, setActiveLink, isMobileMenuOpen, setIsMobileMenuOpen }: { activeLink: string, setActiveLink: (link: string) => void, isMobileMenuOpen: boolean, setIsMobileMenuOpen: (isOpen: boolean) => void }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const links = [
        { name: 'Home' },
        { name: 'About' },
        { name: 'Projects' },
        { name: 'Services' }
    ];

    const mLinks = [
        { name: 'Home' },
        { name: 'About' },
        { name: 'Projects' },
        { name: 'Services' },
        { name: 'Contacts' }
    ];

    const handleLinkClick = (name: string) => {
        setActiveLink(name);
        navigate(name);
        setIsMobileMenuOpen(false);
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    useEffect(() => {
        const pathSegments = location.pathname.split('/').filter(Boolean);
        const currentPath = pathSegments[0] || 'Home';
        setActiveLink(currentPath);
        // eslint-disable-next-line
    }, [location]);

    return (
        <div className='navBar'>
            <div className='top-content-mobile-pc' >
                <div className='logo left-content'>
                    <svg className='logo-svg' width="53" height="44" viewBox="0 0 53 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M34.049 1.42755C33.6207 2.39119 29.3914 11.8669 24.6267 22.4669C19.8621 33.0669 15.8469 42.0609 15.6863 42.4356C15.4722 42.971 15.954 43.1316 17.6671 42.971L19.9156 42.8104L28.1601 24.3407C32.7106 14.169 36.8864 4.85381 37.4753 3.56896C38.4389 1.42755 38.4389 1.26694 37.5823 0.999265C37.1005 0.838659 36.2439 0.463915 35.7086 0.196238C34.9056 -0.232045 34.6379 -0.0179039 34.049 1.42755Z" fill="black" />
                        <path d="M50.4305 0.999252C49.5204 1.374 48.5032 1.85582 48.2355 2.17703C47.9679 2.44471 44.5951 9.77905 40.687 18.4518C36.8325 27.1245 33.085 35.369 32.389 36.7609C31.6395 38.2063 31.2648 39.3306 31.4254 39.3306C32.2284 39.3306 36.5648 35.3154 37.9032 33.2811C39.188 31.4609 53.0002 1.374 53.0002 0.517435C53.0002 0.142688 52.5184 0.249757 50.4305 0.999252Z" fill="black" />
                        <path d="M38.064 8.4407C36.4579 12.0276 32.3892 21.0215 29.07 28.4629C25.7508 35.9043 23.0205 42.0609 23.0205 42.2215C23.0205 42.3821 24.0377 42.168 25.3225 41.8468C28.0528 41.0437 27.1963 42.5963 37.4216 19.6296L45.3448 1.85585H43.1499H40.9549L38.064 8.4407Z" fill="black" />
                        <path d="M0 8.54777C0 8.65484 2.35556 14.0084 5.24648 20.4326C8.1374 26.8569 11.0819 33.4952 11.7778 35.1548C12.4738 36.868 13.1697 38.2599 13.3303 38.2599C13.491 38.2599 14.0798 37.2427 14.6152 35.9579L15.5253 33.6558L10.3324 21.9851L5.08588 10.3144L2.56971 9.3508C1.12425 8.81545 0 8.49424 0 8.54777Z" fill="black" />
                        <path d="M16.2747 8.92248L14.5615 9.45783L16.4353 13.5801C17.506 15.8285 18.7908 18.7194 19.3797 20.0578L20.4504 22.4669L21.4141 20.5932C22.003 19.576 22.4312 18.3982 22.4848 18.0235C22.4848 17.1134 18.6302 8.28005 18.2555 8.33359C18.0949 8.38712 17.1848 8.6548 16.2747 8.92248Z" fill="black" />
                        <path d="M9.79695 10.2609C8.83331 10.3679 8.03027 10.5285 8.03027 10.5821C8.03027 10.6892 10.0646 15.1861 12.4737 20.7003L16.9707 30.6578L18.0414 28.1952L19.0586 25.679L15.5788 17.7558C13.6515 13.4195 11.9384 9.93966 11.7778 9.99319C11.6172 9.99319 10.7071 10.1538 9.79695 10.2609Z" fill="black" />
                    </svg>
                    {!isMobileMenuOpen ?
                        <div className='logo-name' >V2 Constructionss</div>
                        :
                        <div ></div>
                    }
                </div >
                <div className='right-content'>
                    <div className='links'>
                        <ul>
                            {links.map((link, index) => (
                                <li key={index}>
                                    <a
                                        href={link.name}
                                        draggable={false}
                                        className={activeLink === link.name ? 'active' : ''}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleLinkClick(link.name);
                                        }}                                    >
                                        {link.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div
                        onClick={(e) => {
                            e.preventDefault();
                            handleLinkClick('Contacts');
                        }} className='contact-us'>
                        <button>Get In Touch</button>
                    </div>

                    <div className='burger-menu' onClick={toggleMobileMenu}>
                        <div className={`burger-icon ${isMobileMenuOpen ? 'open' : ''}`}>
                            <svg width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 21.9941V18.3275H28V21.9941H0ZM0 12.8275V9.16081H28V12.8275H0ZM0 3.66081V-0.00585938H28V3.66081H0Z" fill="black" />
                            </svg>
                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.9782 12.9999L23.6553 4.32284C23.9786 3.99295 24.1586 3.54881 24.1563 3.08692C24.154 2.62504 23.9695 2.18274 23.6429 1.85613C23.3162 1.52952 22.874 1.34501 22.4121 1.34267C21.9502 1.34034 21.506 1.52038 21.1761 1.84367L12.4991 10.5208L3.82198 1.84367C3.4921 1.52038 3.04795 1.34034 2.58607 1.34267C2.12418 1.34501 1.68188 1.52952 1.35528 1.85613C1.02867 2.18274 0.844152 2.62504 0.841819 3.08692C0.839486 3.54881 1.01953 3.99295 1.34282 4.32284L10.0199 12.9999L1.34282 21.677C1.01953 22.0069 0.839486 22.451 0.841819 22.9129C0.844152 23.3748 1.02867 23.8171 1.35528 24.1437C1.68188 24.4703 2.12418 24.6548 2.58607 24.6572C3.04795 24.6595 3.4921 24.4795 3.82198 24.1562L12.4991 15.4791L21.1761 24.1562C21.506 24.4795 21.9502 24.6595 22.4121 24.6572C22.874 24.6548 23.3162 24.4703 23.6429 24.1437C23.9695 23.8171 24.154 23.3748 24.1563 22.9129C24.1586 22.451 23.9786 22.0069 23.6553 21.677L14.9782 12.9999Z" fill="black" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`bottom-content-mobile ${isMobileMenuOpen ? 'open' : 'closed'}`}>
                <div className='mobile-links'>
                    <ul>
                        {mLinks.map((link, index) => (
                            <li key={index}>
                                <a
                                    href={link.name}
                                    className={activeLink === link.name ? 'active' : ''}
                                    style={activeLink === link.name ? { textDecoration: 'underline', color: 'black' } : undefined}
                                    onClick={() => handleLinkClick(link.name)}
                                >
                                    {link.name}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default NavBar;